<div
	class="form"
	*ngIf="service === 'form'"
	[ngClass]="{ 'cgi--sidebar': type === 'sidebar' }"
>
	<div class="field" *ngFor="let question of cgiQuestions; let index = index">
		<div class="info-row">
			<status-icon
				*ngIf="type === 'page'"
				[number]="index + stepStart"
				[complete]="formArray.controls[index].valid"
			></status-icon>

			<div class="wrap-group">
				<div class="info">{{ question.description }}*</div>		
				<div class="subinfo">
					{{ 'PROMPTUARY.CGI_SEVERITY.DESCRIPTION.CGI.TEXT' | translate }}
					<a href="https://hs-info.zenklub.com/faq/impressao-clinica-global-cgi" rel="noopener" (click)="trackFAQ()" target="_blank">
						{{ 'PROMPTUARY.CGI_SEVERITY.DESCRIPTION.CGI.FAQ_TEXT' | translate }}
					</a>
				</div>
			</div>
		</div>

		<cgi-severity 
			*ngIf="shouldRenderCgiSeverity(question)"
			[severity]="question.selectedOption"
			[type]="question.type"
			mode="promptuary">
		</cgi-severity>

		<div class="options" id="cgi_question_{{ index }}">
			<label *ngFor="let option of question.options" [for]="option.id">
				<input
					type="radio"
					name="cgi"
					[value]="option.radioValue"
					(change)="selectOption(option.id, index)"
					[formControl]="formArray.controls[index]"
				/>
				{{ option.levelDescription }}
			</label>
		</div>
	</div>
</div>

<div class="view" *ngIf="service === 'view'">
	<div class="field" *ngFor="let answer of cgiAnswers">
		<div class="name">{{ answer.question.description }}</div>
		<div class="content">
			{{ answer.option.levelDescription }}
		</div>
	</div>
</div>
